import { TYPE_METER, SAMPLE_PRICE, PRODUCT_STATUSES } from "../constants";

/**
 * @param {import('../routes/server-api/product/types').ProductResponse} product
 * @returns {boolean}
 * */
export function isOnSale(product) {
    return [PRODUCT_STATUSES.CAMPAIGN, PRODUCT_STATUSES.ON_SALE].includes(product.status || "");
}

/**
 * @param {import('../routes/server-api/product/types').ProductResponse} product
 * @param {"price" | "realPrice"} priceProp
 * */
export function getMinPrice(product, priceProp) {
    return Math.min(...product.sizes.map((s) => Number(s[priceProp])));
}
/**
 * @param {import('../routes/server-api/product/types').ProductResponse} product
 * @param {"price" | "realPrice"} priceProp
 * */
export function getMaxPrice(product, priceProp) {
    return Math.max(...product.sizes.map((s) => Number(s[priceProp])));
}

export function calcTotalOrderPrice(order) {
    let price = 0;
    if (!order || !order.products) {
        return price;
    }
    order.products.forEach((p) => (price += Number(p.totalPrice)));
    return price;
}

export const calcCheapestPrice = (orig, current, sales) => {
    if (!sales || !sales.length) {
        return Number(current);
    }
    const highestSalePercent = sales.reduce((highest, curr) => Math.max(Number(highest), Number(curr.salePercent)), 0);
    const salePrice = Math.round(Number(orig) * (1 - highestSalePercent / 100));
    return current < salePrice ? current : salePrice;
};

// This is a variant, so it should only have one size and one color
export const getVariantPrice = (product) => {
    if (product.sample) {
        return getProductSamplePrice(product);
    }

    if (![TYPE_METER].includes(product.type)) {
        return Number(product.sizes[0].price);
    }
    if (product.type === TYPE_METER) {
        const scallopsPrice = product.scallops && product.scallops.length ? Number(product.scallops[0].price) : 0;
        const slidesPrice = product.slides && product.slides.length ? Number(product.slides[0].price) : 0;
        return Math.round(slidesPrice + scallopsPrice + Number(product.sizes[0].price));
    }
    return 0;
};

/**
 * @param {number | null} amount
 */
export const formatCurrency = (amount = 0, currency = "kr") => {
    if (amount === null) {
        return amount;
    }
    amount = Number(amount);

    const sum =
        amount === parseInt(String(amount))
            ? amount.toLocaleString("sv-SE") + ",00"
            : parseFloat(amount.toFixed(2)).toLocaleString("sv-SE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              });
    return `${sum} ${currency}`;
};

export const getTotalCartPrice = (products) => {
    return products.map((product) => getVariantPrice(product) * product.num).reduce((tot, product) => tot + product, 0);
};

export const getTotalOrderPrice = (products) => {
    return products.map((product) => Number(product.totalPrice)).reduce((tot, product) => tot + product, 0);
};

/**
 *
 * @param {import('../routes/server-api/product/types').ProductResponse} product
 * @returns {number}
 */
export function getProductSamplePrice(product) {
    return product.samplePrice ?? SAMPLE_PRICE;
}
